const INITIAL_STATE = {
  fields: []
}

const reducer = (state = INITIAL_STATE, action) => {

  switch (action.type) {

  case 'MOVE':
    return {
      ...state,
      fields: (action.from < action.to) ? [
        ...state.fields.slice(0, action.from),
        ...state.fields.slice(action.from + 1, action.to + 1),
        state.fields[action.from],
        ...state.fields.slice(action.to + 1)
      ] : [
        ...state.fields.slice(0, action.to),
        state.fields[action.from],
        ...state.fields.slice(action.to, action.from),
        ...state.fields.slice(action.from + 1)
      ]
    }

  case 'SET':
    return {
      ...state,
      fields: action.fields
    }

  default:
    return state
  }

}

export default reducer
